/**
 * @Author: Nenad Brcic
 * @Date: 22.05.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import {Link} from 'react-router';
import styles from './toolbar.scss';
import CSSModules from 'react-css-modules';
import Icon from '../Icon';
import { getCurrentLanguage } from '../../../localData';

const Toolbar = ({ handleSharing, handleAddToMyCollection }) => {

    const highlightElement = (classSelector) => {
        const l = document.getElementsByClassName(classSelector)[0];
        const highlightClass = 'is-highlight';

        l.className += ` ${highlightClass}`;
        window.setTimeout(function () {
            l.className = l.className.replace(highlightClass, '');
        }, 3000);
    };

    const addToMyCollection = () => {
        handleAddToMyCollection();
        highlightElement('link-go-to-my-collection');
    };

    return (
        <div styleName="toolbar">
            <div className="content-box">
                <button className="button-share"
                        onClick={ handleSharing }
                >
                    <Icon icon="Vitra_Share.svg" />
                </button>
                <button className="button-add-to-my-collection"
                        onClick={ addToMyCollection }
                >
                    <Icon icon="Vitra_Save.svg" />
                </button>
                <Link className="link-go-to-my-collection"
                        to={ `/${getCurrentLanguage()}/mycollection` }
                >
                    <Icon icon="Vitra_Collection.svg" />
                </Link>
            </div>
        </div>
    )
};

Toolbar.propTypes = {
    handleSharing: PropTypes.func.isRequired,
    handleAddToMyCollection: PropTypes.func.isRequired,
};

export default CSSModules(Toolbar, styles);


// WEBPACK FOOTER //
// ./app/components/shared/Toolbar/index.jsx